import {
  type ConnectorLike,
  readyForConnectionTest,
} from "../../shared/connectors/isDraft";
import { useHasAccess } from "./useHasAccess";
import { useMyConnectorGrants } from "./useMyConnectorGrants";

export function useVisitorTestReadiness(
  app: (ConnectorLike & { id: string }) | undefined
) {
  const visitor = app?.authorizationMode === "visitor";
  const canManage = useHasAccess("connected_app:write", app?.id);
  const [grants] = useMyConnectorGrants({ enabled: visitor });
  const callerGrant = grants.find(
    (grant) => grant.connectedAppId === app?.id && grant.subjectKind === "user"
  );
  const visitorReady =
    !!app && canManage && readyForConnectionTest(app, callerGrant);
  return { visitor, canManage, visitorReady };
}
